<template>
  <div>
    <div
      class="mask"
      :class="{ maskActive: isOpenStockDialog }"
      @click="isOpenStockDialog = false"
    />
    <!-- mb版 上滑popup -->
    <transition name="slide-up">
      <div
        v-if="isOpenStockDialog"
        id="dialog-market"
        :class="{ active: isOpenStockDialog }"
        class="dialog-bottom stock-modal"
      >
        <div class="dialog-inner">
          <div class="cart-content">
            <a class="btn-delete" @click="isOpenStockDialog = false">
              <i class="icon-close" />
            </a>
            <div class="item-detail" @click.prevent="closeSelect">
              <div class="item-info">
                <div class="item-order">
                  <div class="brand-name">
                    {{ itemDatas.Brand?.Name }}
                  </div>
                  <div class="item-name">
                    {{ itemDatas.Name }}
                  </div>
                </div>
              </div>
            </div>
            <div class="item-pick">
              <div class="select-block">
                <div class="select-style" :class="{ spread: sizeBtn }">
                  <a class="select-btn" @click.prevent.stop="openSelector">{{
                    selectedData.Name
                  }}</a>
                  <ul class="select-opts" :class="{ isopen: selectIsOpen }">
                    <li
                      v-for="color in itemDatas.Colors"
                      :key="color.ID"
                      @click.prevent="changeColor(color.ID)"
                    >
                      {{ color.Name }}
                    </li>
                  </ul>
                </div>
                <Selector
                  v-if="!sizeBtn"
                  :options="selectedData.Specs"
                  :selected="selectedSpec"
                  :is-shop-stock="true"
                  :stock-list="weakSelectedState"
                  @cb="changeSize"
                />
              </div>
            </div>
          </div>
          <div class="stock-content">
            <div class="shop-list">
              <div
                v-if="seletedSize != '' && Object.keys(filterAreaList).length === 0"
                class="no-select"
              >
                此商品門市暫無庫存
              </div>
              <div v-else class="is-stock">
                <div>列表</div>
                <div v-if="Object.keys(filterAreaList).length > 0">有庫存</div>
              </div>

              <div v-for="(area, key, index) in filterAreaList" :key="index" class="area">
                <div class="area-title">{{ key }}</div>
                <div v-for="(info, id) in area" :key="id" class="area-shop-list">
                  <div class="info">
                    <div class="shop-name">{{ info.Name }}</div>
                    <div>
                      <a class="shop-address" :href="info.MapUrl">
                        {{ info.Address }}
                        <img
                          src="https://static.tpx.tw/sff/pazzo-v2/static/img/location.png"
                          alt=""
                        />
                      </a>
                    </div>
                  </div>
                  <div class="size">
                    {{ selectedSizeName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="store-stock">
            <div class="store-stock-tips">
              溫馨提醒
              <br />
              ※ 庫存狀況並非即時狀態，店舖有可能已銷售完畢。
              <br />
              ※ 門市不提供電話或他店訂購及保留的服務。
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import { fireInStoreInventory } from '@global/gtm/product';

import useShopContentStore from '@global/stores/useShopContentStore';
import useMsg from '@global/composable/useMessage';
import useAlert from '@global/composable/useAlert';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

import Selector from '@components/Select.vue';

const { getStockDataApi } = useAxiosAPI();

const category = window.ItemCategories[0];

const shopContentStore = useShopContentStore();
const {
  selectedData,
  itemDatas,
  selectedSpec,
  selectIsOpen,
  isOpenStockDialog,
  selectedSpecID,
  selectedSpecKey,
} = storeToRefs(shopContentStore);

const { openSelector, selectSpec, changeImg } = shopContentStore;

const areaList = ref([]);
const filterAreaList = ref({});
const seletedSize = ref('');
const selectedSizeName = ref('');
const weakSelectedState = ref({});

const sizeBtn = computed(() => {
  return (
    // 非服飾類 & 單一顏色尺寸 & 尺寸為F，須隱藏尺寸下拉選單
    category !== '服飾' &&
    selectedData.value.Specs?.length === 1 &&
    selectedData.value.Specs[0]?.Name === 'F' &&
    selectedData.value.Specs[0]?.Stock > 0
  );
});

watch(
  [selectedData, isOpenStockDialog],
  async ([newSelectValue, newOpenStockValue]) => {
    if (!newOpenStockValue) return;
    if (newSelectValue.Specs.length === 0) return;
    const Specs = [];
    newSelectValue.Specs.forEach((e) => {
      Specs.push(e.Barcode);
    });
    await getStockData(Specs.join());

    if (newSelectValue.Specs.length === 1) {
      changeSize(newSelectValue.Specs[0]);
    }

    if (newSelectValue.Specs.length > 1) {
      for (const e of newSelectValue.Specs) {
        if (e.ID === selectedSpecID.value) {
          changeSize(e);
          break;
        }
      }
    }

    await nextTick(() => {
      const map = {};
      newSelectValue.Specs.forEach((spec) => {
        map[spec.Barcode] = isSizeWeak(spec.Barcode);
      });
      weakSelectedState.value = map;
    });
  },
  { immediate: true },
);

async function getStockData(barcode = '') {
  try {
    const res = await getStockDataApi({
      params: {
        Barcodes: barcode,
      },
    });

    areaList.value = res.data.Response.Branches.map((e) => ({
      ...e,
      Stocks: e.Stocks?.filter((f) => Number(f.Quantity) > 0) || [],
    }));
  } catch (error) {
    console.log(error);
  }
}

function changeSize(spec) {
  filterAreaList.value = {};
  selectSpec(spec);
  seletedSize.value = spec.Barcode;
  selectedSizeName.value = spec.Name;

  const list = areaList.value.filter((e) => {
    return e.Stocks.some((f) => f.Barcode === seletedSize.value);
  });

  filterAreaList.value = list.reduce((acc, e) => {
    (acc[e.City] ||= []).push(e);
    return acc;
  }, {});

  const customMarketID = itemDatas.value.CustomMarketID;
  const subStringCustomMarketID = customMarketID.substring(0, customMarketID.indexOf('CL'));
  const itemSpecInfo = `${subStringCustomMarketID}CL${selectedData.value.ID}SZ${selectedSpecKey.value}`;
  const gtmList = list.map((e) => {
    return {
      StoreName: e.Name,
      Size: selectedSizeName.value,
    };
  });

  fireInStoreInventory({
    ProductId: itemSpecInfo,
    ProductName: itemDatas.value.Name,
    HashId: window.Email,
    pColor: selectedData.value.Name,
    pSize: selectedSizeName.value,
    pStoreList: gtmList,
  });
}

function changeColor(color) {
  if (selectedData.value.ID === color) return;
  changeImg(color);
  filterAreaList.value = {};
  seletedSize.value = '';
  selectedSizeName.value = '';
}

function isSizeWeak(barcode) {
  const barcodeList = [];
  areaList.value.forEach((e) => {
    e.Stocks.forEach((f) => {
      barcodeList.push(f.Barcode);
    });
  });

  return barcodeList.includes(barcode);
}
</script>
